'use client';

import { __makeTemplateObject, __rest, __assign } from '../_virtual/_tslib.js';
import React__default, { forwardRef, useMemo, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { renderCssStringOfRow, renderCssStringOfContainer } from './helper.js';
import LayoutContext from './LayoutContext.js';
import { alignValues } from './constants.js';

var RowLayout = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: ", ";\n    justify-content: ", ";\n    ", ";\n"], ["\n    box-sizing: border-box;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: ", ";\n    justify-content: ", ";\n    ", ";\n"])), function (_a) {
    var align = _a.align;
    return alignValues[align];
}, function (_a) {
    var justify = _a.justify;
    return justify;
}, function (_a) {
    var cssString = _a.cssString;
    return cssString;
});
var ContainerLayout = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var containerCssString = _a.containerCssString;
    return containerCssString;
});
var Row = forwardRef(function (_a, ref) {
    var _b = _a.gutter, gutter = _b === void 0 ? 0 : _b, _c = _a.align, align = _c === void 0 ? 'top' : _c, _d = _a.justify, justify = _d === void 0 ? 'start' : _d, container = _a.container, children = _a.children, restProps = __rest(_a, ["gutter", "align", "justify", "container", "children"]);
    var rowCssString = useMemo(function () { return renderCssStringOfRow(gutter); }, [gutter]);
    var containerCssString = useMemo(function () { return renderCssStringOfContainer(container); }, [container]);
    var props = useRef({
        gutter: gutter
    });
    var renderContainerLayout = useCallback(function (children) {
        if (container) {
            return (React__default.createElement(ContainerLayout, { className: 'vnwLayout__container', containerCssString: containerCssString }, children));
        }
        return children;
    }, [container, containerCssString]);
    return renderContainerLayout(React__default.createElement(RowLayout, __assign({ id: 'vnwLayout__row', cssString: rowCssString, align: align, justify: justify, ref: ref }, restProps),
        React__default.createElement(LayoutContext.Provider, { value: props.current }, children)));
});
var templateObject_1, templateObject_2;

export { Row as default };
//# sourceMappingURL=Row.js.map
